export default "__VITE_PUBLIC_ASSET__def7dd72__"